<template>
  <div class="flex flex-wrap justify-content-end align-items-center">
    <Button
      :disabled="undoDisabled"
      :label="undoLabel"
      class="p-button-danger p-button-outlined mr-2"
      data-cy="undoConfirmButtons-undo"
      @click="$emit('undo')"
    />
    <slot></slot>
    <Button
      :disabled="confirmDisabled"
      :label="confirmLabel"
      class="p-button-info"
      data-cy="undoConfirmButtons-confirm"
      @click="$emit('confirm')"
    />
  </div>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps({
  undoLabel: {
    type: String,
    default: "Undo"
  },
  confirmLabel: {
    type: String,
    default: "Save"
  },
  confirmDisabled: {
    type: Boolean,
    default: false
  },
  undoDisabled: {
    type: Boolean,
    default: false
  }
});

defineEmits<{
  (e: "undo"): void;
  (e: "confirm"): void;
}>();

const { undoLabel, confirmLabel, confirmDisabled, undoDisabled } = toRefs(props);
</script>
